module.exports = __webpack_public_path__ + "73aaa95eab3115ea5a1e5c1cf16ea645.woff2";